
const AWS = require('aws-sdk');
const {Region} = require("./env");
const {ErrorResponse, SuccessResponse} = require("./response");

const getSESService = (creds) => {
  if (creds) {
    return new AWS.SES(creds.to_service());
  }

  if (Region.region) {
    return new AWS.SES({
      region: Region.region,
    })
  }
  return new AWS.SES();
}

const SendEmail = async (
  to_address, cc_address, bcc_address, source, message_html, subject) => {
  return await SendEmailC(
    null, to_address, cc_address, bcc_address, source, message_html, subject);
}

const SendEmailC = async (
  creds, to_address, cc_address, bcc_address, source, message_html, subject) => {

  const params = {
    Message: {
      Body: {
        Html: {
          Data: message_html,
        },
      },
      Subject: {
        Data: subject,
      },
    },
    Source: source,
    Destination: {},
  };

  if (to_address) {
    params.Destination.ToAddresses = to_address;
  }
  if (cc_address) {
    params.Destination.CcAddresses = cc_address;
  }
  if (bcc_address) {
    params.Destination.BccAddresses = bcc_address;
  }

  const ses = getSESService(creds);

  try {
    return SuccessResponse(await ses.sendEmail(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
};


/**
 * @param creds {CaCredentials|null}
 * @param message {RawMessageData}
 */
const SendRawEmail = async (creds, message) => {

  const ses = getSESService(creds);

  const params = {
    RawMessage: {
      Data: message,
    }
  };

  try {
    return SuccessResponse(await ses.sendRawEmail(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

module.exports = {
  SendEmail, SendEmailC, SendRawEmail,
}
